import './polyfills';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './views/App';

ReactDOM.hydrate(<App />, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js